var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form", attrs: { novalidate: "" } },
        [
          _c("section-title", {
            attrs: {
              "container-class": "tag-badge-main-info mt-4 mb-4",
              content: "I. Datos de Identificación del Participante (Parte A)",
              icon: "fas fa-clipboard-list-check"
            }
          }),
          _c("participant-info-section", {
            attrs: {
              "is-read-only": _vm.isReadOnly,
              "other-conditions": _vm.otherConditions
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _c("guardian-info-section", { attrs: { model: _vm.model } }),
          _c("location-info-section", { attrs: { model: _vm.model } }),
          _c("school-info-section", { attrs: { model: _vm.model } }),
          _c("referral-report-section", {
            attrs: { "is-read-only": _vm.isReadOnly },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          }),
          _vm.model.evaluator
            ? _c("evaluator-section", {
                attrs: { "is-read-only": _vm.isReadOnly },
                model: {
                  value: _vm.model,
                  callback: function($$v) {
                    _vm.model = $$v
                  },
                  expression: "model"
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }